import { MethodEnum } from '@enum/method.enum';
import { isString } from '@util/data/is-exist';

export const curlTemplate = (
  link: string,
  headers: Record<string, string> = {},
  body: Record<string, string> = {},
  method: MethodEnum = MethodEnum.GET,
) => {
  const headersText = Object.entries(headers)
    .filter(([, value]) => isString(value))
    .map(([key, value]) => `--header '${key}: ${value}'`);

  return `curl --location '${encodeURI(link)}' -X ${method} \\
${headersText.join(' \\ \n')} \\
${`--data '${JSON.stringify(body)}'`}
`;
};
